let getApi = () => import('@/services/Api');

const state = {
    dtiItemList: [],
    pageKey: 0
};

const getters = {
    getDtiItemList: (state) => state.dtiItemList,

};
const actions = {
    async storeDtiItemList({commit, dispatch, rootGetters}, payload) {
        if (!payload) return commit('setDtiItemList', []);
        try {
            const {http} = await getApi();
            let url, requestObj = null;
            if (rootGetters.getRouteName === 'AssetPage') {
                url = `/search/employee`;
                requestObj = {q: payload.employeeSearchString, assetId: payload.assetId}
            } else if(rootGetters.getRouteName === 'EmployeePage') {
                url = `view/Asset/`;
                requestObj = {
                    where: [{
                        value: 'identNumber',
                        text: `${payload.identNumber}%`,
                        operator: 'like'
                    }]
                }
            }
            let response = await http.getData(url, requestObj);
            if (response.status === 200 && response.data.tabRows) {
                const rows = (rootGetters.getRouteName === 'EmployeePage')
                    ? response.data.tabRows.filter(item => Number(item.identNumber) > 500000)
                    : response.data.tabRows;
                commit('setDtiItemList', rows);
            } else {
                dispatch('storeError', `Приспособление не найдено `, "UP_asset_not_found_error", {root: true});
            }
        } catch (e) {
            dispatch('storeError', e, {root: true});
        }
    },

};
const mutations = {
    setDtiItemList: (state, data) => {
        state.dtiItemList = [...data]
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}
